import React, { useCallback, useEffect } from 'react';
import { useDropzone, Accept } from 'react-dropzone';
import {
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

interface Props {
  onFileAccepted: (files: File) => void;
  accept?: Accept;
  maxFiles?: number;
  hasError: any;
  file?: File;
}

const DragDropUpload: React.FC<Props> = ({
  onFileAccepted,
  accept = {
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
      '.docx',
    ],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
  },
  maxFiles = 5,
  hasError,
  file,
}) => {

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        onFileAccepted(acceptedFiles[0]);
      }
    },
    [onFileAccepted]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    maxFiles,
  });

  return (
    <Paper
      {...getRootProps()}
      variant='outlined'
      sx={{
        p: 4,
        textAlign: 'center',
        borderStyle: 'dashed',
        backgroundColor: isDragActive ? 'grey.100' : 'background.paper',
        cursor: 'pointer',
        transition: '0.2s ease',
        borderColor: hasError ? 'error.main' : 'divider',
      }}
    >
      <input {...getInputProps()} />
      <UploadFileIcon fontSize='large' color='primary' />
      <Typography variant='h6' mt={2}>
        {isDragActive
          ? 'Drop the files here...'
          : 'Drag & drop files here, or click to select'}
      </Typography>

      {file && (
        <List>
          <ListItem>
            <ListItemIcon>
              <UploadFileIcon />
            </ListItemIcon>
            <ListItemText
              primary={file?.name}
              secondary={`${file?.size && (file?.size / 1024).toFixed(1)} KB`}
            />
          </ListItem>
        </List>
      )}
    </Paper>
  );
};

export default DragDropUpload;
